var React = require('react');

function GreenShieldInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"prefix__Shield_filled_","d":"M11.354 1.528C8.882 3.507 6.661 4.753 3.5 4.967a1.045 1.045 0 0 0-.989 1.043c.345 15.023 8.378 16.81 9.385 16.975a.635.635 0 0 0 .207 0c1.007-.165 9.04-1.952 9.385-16.975a1.045 1.045 0 0 0-.988-1.043c-3.161-.214-5.382-1.46-7.854-3.439a1.034 1.034 0 0 0-1.292 0zm5.282 8.608a.9.9 0 0 0-1.273-1.273L11 13.227l-1.864-1.863a.9.9 0 0 0-1.273 1.273l2.5 2.5a.9.9 0 0 0 1.273 0z","data-name":"Shield (filled)","transform":"translate(-2.511 -1.302)","style":{"fill":"#417e2a","fillRule":"evenodd"}}));
}

GreenShieldInline.defaultProps = {"width":"18.978","height":"21.692","viewBox":"0 0 18.978 21.692"};

module.exports = GreenShieldInline;

GreenShieldInline.default = GreenShieldInline;
